import { Injectable } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root'
})
export class AppSettings {

  public static GOOGLE_AUTH_CONFIG: AuthConfig = {
      issuer: 'https://accounts.google.com',
      redirectUri: window.location.origin + '/welcome',
      responseType: 'code',
      scope: 'email profile',
      showDebugInformation: true,
      strictDiscoveryDocumentValidation: false,
      useSilentRefresh: true, // set to true if implementing silent refresh
      silentRefreshRedirectUri: `${window.location.origin}`, // only needed if silent refresh is used
      disablePKCE: false,
      checkOrigin: true,
      customQueryParams: {
        hd: 'amrize.com'
      }
  }
}
